import React from "react";
import NavContainer from "./NavContainer";
import NavItem from "./NavItem";
import { Compass, Home, LayoutGrid, Search, User } from "lucide-react";

const BottomNavigation = () => {
  return (
    <NavContainer>
      <NavItem icon={<Home className="h-5 w-5" />} title="Home" path="/" />
      <NavItem
        icon={<LayoutGrid className="h-5 w-5" />}
        title="Categories"
        path="/categories"
      />
      <NavItem
        icon={<Compass className="h-5 w-5" />}
        title="Explore"
        path="/explore"
      />
      <NavItem
        icon={<Search className="h-5 w-5" />}
        title="Search"
        path="/search"
      />
      <NavItem
        icon={<User className="h-5 w-5" />}
        title="Account"
        path="/accounts"
      />
    </NavContainer>
  );
};

export default BottomNavigation;
